<template>
    <v-container fluid>
        <div v-if="!loading"> 
            <!--table head-->
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Functional Expansion acceptance
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--acceptance tab-->
            <div v-if="advancedFeatures?.length" >       
                <v-row v-for="item in advancedFeatures"
                    :key="item.id" no-gutters>
                    <v-col class="tabCell text-truncate text-left">{{ item.segment?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.positioning_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.power_bank_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.missed_items_warning_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.danger_alarm_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.fridge_camera_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.loss_insurance_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.friendly_utilization_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.profit_sharing_acceptance, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.individual_pictures_acceptance, 2) }}</v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4"
                justify="center">
                there are no acceptance yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber, roundNumber } from '../../../functions/common';
export default {
    data() {
        return {
            headers: [
                { title: 'segment', style: 'text-left' },
                { title: 'positioning tracker', style: 'text-center' },
                { title: 'power bank', style: 'text-center' },
                { title: 'missed items warning', style: 'text-center' },
                { title: 'danger alarm', style: 'text-center' },
                { title: 'fridge camera', style: 'text-center' },
                { title: 'loss insurance', style: 'text-center' },
                { title: 'environment friendly utilization', style: 'text-center' },
                { title: 'profit sharing', style: 'text-center' },
                { title: 'individual pictures', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        advancedFeatures() {
            return this.$store.getters.advancedFeatures;
        },
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        formatNumber(num, dec) {
            return roundNumber(num, dec);
        }
    },
    components: { Loader }
}
</script>